export default __webpack_public_path__ + "static/media/menu_photo_3@2x.a91e5076.png";